import React, {useState} from 'react'
import { Check, Download, X } from 'lucide-react'
import {envVariables} from '../../utils/envVariables/envVariables'

export const ExportProductSidebar = ({actionMenuNormal, setDownloadCSV, csvLinkRef, idPromocion, showSapExcelOption = false, typePromotion}) => {
	const [steps, setSteps] = useState(1)
	const [optionCSV, setOptionCSV] = useState(false);
	const [optionPDF, setOptionPDF] = useState(false);
	const [optionSapExcel, setOptionSapExcel] = useState(false);
	const [optionBulkTemplate, setOptionBulkTemplate] = useState(false);
	const sapExcelUrl = `${envVariables.baseUrl}/promotion/export/sap?id_promo=${encodeURIComponent(idPromocion)}`
	const bulkTemplateType = String(typePromotion).toUpperCase() === 'SELL-IN' ? 'sellin' : 'sellout'
	const bulkTemplateUrl = `${envVariables.baseUrl}/promotion/bulk/template/${bulkTemplateType}?id_promocion=${encodeURIComponent(idPromocion)}`

	const downloadExcelFile = async (url, filename, errorLabel) => {
		const sessionToken = localStorage.getItem('token')
		try {
			const response = await fetch(url, {
				method: 'GET',
				headers: {
					Authorization: 'Bearer ' + sessionToken,
				},
			})

			if (!response.ok) {
				throw new Error(`Error ${response.status}`)
			}

			const blob = await response.blob()
			const downloadUrl = window.URL.createObjectURL(blob)
			const link = document.createElement('a')
			link.href = downloadUrl
			link.download = filename
			document.body.appendChild(link)
			link.click()
			link.remove()
			window.URL.revokeObjectURL(downloadUrl)
		} catch (error) {
			console.log(`Error exportando ${errorLabel}:`, error)
			alert(`No fue posible exportar ${errorLabel}. Intenta nuevamente.`)
		}
	}

	const downloadSapExcel = () => {
		downloadExcelFile(
			sapExcelUrl,
			`formato-sap-${idPromocion}.xlsx`,
			'el Formato SAP Excel'
		)
	}

	const downloadBulkTemplate = () => {
		downloadExcelFile(
			bulkTemplateUrl,
			`formato-carga-masiva-${bulkTemplateType}-${idPromocion}.xlsx`,
			'el Formato para Carga Masiva'
		)
	}

	return (
		<div className='AddProductSdebar'>
			<div className='topbar'>
				<h1>Exportar</h1>
			</div>

			<div className='form-wrapper-area MoverProductSidebar ExportProductSidebar'>
				{steps === 1 && (
					<div className='first'>
						<h1>
							Selecciona el formato en el que deseas exportar    el Catálogo:
						</h1>
						{ /*
						<div className='box '>
							<input type='checkbox' name='' id='PDF' 
							onChange={() => {
								if (optionPDF) {
								  // Si ya está marcado y lo desmarcan, puedes hacer algo aquí si es necesario
								  setOptionPDF(false); // Desmarca el checkbox
								} else {
								  // Si no está marcado y lo marcan, puedes hacer algo aquí si es necesario
								  setOptionPDF(true); // Marca el checkbox
								}
							  }}
							/>
							<label htmlFor='PDF'>
								<svg
									width='11'
									height='8'
									viewBox='0 0 11 8'
									fill='none'
									xmlns='http://www.w3.org/2000/svg'
								>
									<path
										d='M3.78918 8C3.68417 8 3.58499 7.98257 3.49165 7.94771C3.3983 7.91285 3.31079 7.85476 3.22912 7.77342L0.218775 4.7756C0.0670908 4.62455 -0.00571732 4.43561 0.00035004 4.2088C0.00595068 3.98245 0.0845929 3.79375 0.236277 3.6427C0.387961 3.49165 0.577682 3.41612 0.805441 3.41612C1.03273 3.41612 1.21639 3.49165 1.3564 3.6427L3.78918 6.06536L9.65235 0.226579C9.79236 0.0755264 9.97905 0 10.2124 0C10.4458 0 10.6383 0.0755264 10.79 0.226579C10.93 0.377632 11 0.566333 11 0.79268C11 1.01949 10.93 1.20842 10.79 1.35948L4.34924 7.77342C4.26757 7.85476 4.18006 7.91285 4.08671 7.94771C3.99337 7.98257 3.89419 8 3.78918 8Z'
										fill='white'
									/>
								</svg>
							</label>
							<div className='presentation'>
								<h1>PDF</h1>
								<p>Ideal para presentaciones. Este formato no es editable.</p>
							</div>
						</div>
						*/}
						<div className='box'>
							<input type='checkbox' name='' id='CSV' 
							checked={optionCSV} 
							onChange={() => {
								if (optionCSV) {
								  // Si ya está marcado y lo desmarcan, puedes hacer algo aquí si es necesario
								  setOptionCSV(false); // Desmarca el checkbox
								} else {
								  // Si no está marcado y lo marcan, puedes hacer algo aquí si es necesario
								  setOptionCSV(true); // Marca el checkbox
								}
							  }}
							/>
							<label htmlFor='CSV'>
								<svg
									width='11'
									height='8'
									viewBox='0 0 11 8'
									fill='none'
									xmlns='http://www.w3.org/2000/svg'
								>
									<path
										d='M3.78918 8C3.68417 8 3.58499 7.98257 3.49165 7.94771C3.3983 7.91285 3.31079 7.85476 3.22912 7.77342L0.218775 4.7756C0.0670908 4.62455 -0.00571732 4.43561 0.00035004 4.2088C0.00595068 3.98245 0.0845929 3.79375 0.236277 3.6427C0.387961 3.49165 0.577682 3.41612 0.805441 3.41612C1.03273 3.41612 1.21639 3.49165 1.3564 3.6427L3.78918 6.06536L9.65235 0.226579C9.79236 0.0755264 9.97905 0 10.2124 0C10.4458 0 10.6383 0.0755264 10.79 0.226579C10.93 0.377632 11 0.566333 11 0.79268C11 1.01949 10.93 1.20842 10.79 1.35948L4.34924 7.77342C4.26757 7.85476 4.18006 7.91285 4.08671 7.94771C3.99337 7.98257 3.89419 8 3.78918 8Z'
										fill='white'
									/>
								</svg>
							</label>
							<div className='presentation'>
								<h1>CSV</h1>
								<p>
									Ideal para editar fuera de la plataforma. Este formato es
									editable.
								</p>
							</div>
						</div>
						<div className='box' style={!showSapExcelOption ? {opacity: 0.55} : null}>
							<input type='checkbox' name='' id='SAP_EXCEL'
							checked={optionSapExcel}
							disabled={!showSapExcelOption}
							onChange={() => {
								if (!showSapExcelOption) {
									setOptionSapExcel(false);
									return;
								}
								setOptionSapExcel(!optionSapExcel);
							}}
							/>
							<label htmlFor='SAP_EXCEL'>
								<svg
									width='11'
									height='8'
									viewBox='0 0 11 8'
									fill='none'
									xmlns='http://www.w3.org/2000/svg'
								>
									<path
										d='M3.78918 8C3.68417 8 3.58499 7.98257 3.49165 7.94771C3.3983 7.91285 3.31079 7.85476 3.22912 7.77342L0.218775 4.7756C0.0670908 4.62455 -0.00571732 4.43561 0.00035004 4.2088C0.00595068 3.98245 0.0845929 3.79375 0.236277 3.6427C0.387961 3.49165 0.577682 3.41612 0.805441 3.41612C1.03273 3.41612 1.21639 3.49165 1.3564 3.6427L3.78918 6.06536L9.65235 0.226579C9.79236 0.0755264 9.97905 0 10.2124 0C10.4458 0 10.6383 0.0755264 10.79 0.226579C10.93 0.377632 11 0.566333 11 0.79268C11 1.01949 10.93 1.20842 10.79 1.35948L4.34924 7.77342C4.26757 7.85476 4.18006 7.91285 4.08671 7.94771C3.99337 7.98257 3.89419 8 3.78918 8Z'
										fill='white'
									/>
								</svg>
							</label>
							<div className='presentation'>
								<h1>Formato SAP Excel</h1>
								<p>
									{showSapExcelOption
										? 'Archivo Excel para descargar el catálogo en formato SAP.'
										: 'Esta opción solo se activa cuando la promoción es confirmada.'}
								</p>
							</div>
						</div>
						<div className='box'>
							<input type='checkbox' name='' id='BULK_TEMPLATE'
							checked={optionBulkTemplate}
							onChange={() => {
								setOptionBulkTemplate(!optionBulkTemplate);
							}}
							/>
							<label htmlFor='BULK_TEMPLATE'>
								<svg
									width='11'
									height='8'
									viewBox='0 0 11 8'
									fill='none'
									xmlns='http://www.w3.org/2000/svg'
								>
									<path
										d='M3.78918 8C3.68417 8 3.58499 7.98257 3.49165 7.94771C3.3983 7.91285 3.31079 7.85476 3.22912 7.77342L0.218775 4.7756C0.0670908 4.62455 -0.00571732 4.43561 0.00035004 4.2088C0.00595068 3.98245 0.0845929 3.79375 0.236277 3.6427C0.387961 3.49165 0.577682 3.41612 0.805441 3.41612C1.03273 3.41612 1.21639 3.49165 1.3564 3.6427L3.78918 6.06536L9.65235 0.226579C9.79236 0.0755264 9.97905 0 10.2124 0C10.4458 0 10.6383 0.0755264 10.79 0.226579C10.93 0.377632 11 0.566333 11 0.79268C11 1.01949 10.93 1.20842 10.79 1.35948L4.34924 7.77342C4.26757 7.85476 4.18006 7.91285 4.08671 7.94771C3.99337 7.98257 3.89419 8 3.78918 8Z'
										fill='white'
									/>
								</svg>
							</label>
							<div className='presentation'>
								<h1>Formato para Carga Masiva</h1>
								<p>
									Archivo Excel para cargar productos en un nuevo catálogo.
								</p>
							</div>
						</div>
						<div className='buttons-wrapper' style={{marginTop: 50}}>
							<button 
							onClick={(e) => {
								actionMenuNormal()
							}}
							>Cancelar</button>
							<button
								onClick={(e) => {
									if(optionSapExcel){
										downloadSapExcel();
									}
									if(optionBulkTemplate){
										downloadBulkTemplate();
									}
									setSteps(2)
									setTimeout(() => {
										setSteps(3)
									}, 1500)
									setTimeout(() => {
										if(optionPDF){
											window.print();
										}
										if(optionCSV){
											csvLinkRef.current.link.click();
										}
									}, 2000)
								}}

								disabled={!optionCSV && !optionPDF && !optionSapExcel && !optionBulkTemplate}
							>
								Exportar
							</button>
						</div>
					</div>
				)}
				{steps === 2 && (
					<div className='first third-step'>
						<h1>Generando archivos</h1>
					{optionCSV && (
						<div className='upload-box'>
							<small>download.csv</small>
							<h1>Descargando</h1>
							<div className='row-upload-box'>
								<Download size={16} color="#3676F5" />
								<div className='line'>
									<div className='inner_line'></div>
								</div>
								<X size={14} color="#3676F5" />
							</div>
							<span>En Proceso</span>
							<span></span>
						</div>
					)}
					{optionPDF && (
						<div className='upload-box'>
							<small >download.pdf</small>
							<h1>Descargando</h1>
							<div className='row-upload-box'>
								<Download size={16} color="#3676F5" />
								<div className='line'>
									<div className='inner_line'></div>
								</div>
								<X size={14} color="#3676F5" />
							</div>
							<span>En Proceso</span>
							<span></span>
						</div>
					)}	
					{optionSapExcel && (
						<div className='upload-box'>
							<small>formato-sap.xlsx</small>
							<h1>Descargando</h1>
							<div className='row-upload-box'>
								<Download size={16} color="#3676F5" />
								<div className='line'>
									<div className='inner_line'></div>
								</div>
								<X size={14} color="#3676F5" />
							</div>
							<span>En Proceso</span>
							<span></span>
						</div>
					)}
					{optionBulkTemplate && (
						<div className='upload-box'>
							<small>formato-carga-masiva.xlsx</small>
							<h1>Descargando</h1>
							<div className='row-upload-box'>
								<Download size={16} color="#3676F5" />
								<div className='line'>
									<div className='inner_line'></div>
								</div>
								<X size={14} color="#3676F5" />
							</div>
							<span>En Proceso</span>
							<span></span>
						</div>
					)}
						<div
							className='buttons-wrapper'
							style={{gridTemplateColumns: '1fr', marginTop: 50}}
						>
							<button
							onClick={(e) => {
								actionMenuNormal()
							}}
							>Cancelar Descarga</button>
						</div>
					</div>
				)}
				{steps === 3 && (
					<div className='first third-step'>
						<h1>Archivos Generados</h1>
						<p>Presiona la(s) siguiente(s) opción(es)</p>
						{optionCSV && (
						<div className='box '>
							<Check size={14} color="#3676F5" />
							<div className='presentation'>
								<h1
								onClick={(e) => {
									csvLinkRef.current.link.click();
								}}
								>download.csv</h1>
								<p>Columnas separadas por coma</p>
							</div>
						</div>
					)}
					{optionPDF && (
						<div className='box '
						onClick={(e) => {
							window.print();
						}}
						>
							<Check size={14} color="#3676F5" />
							<div className='presentation'>
								<h1>download.pdf</h1>
								<p>PDF de vista en plataforma</p>
							</div>
						</div>
					)}
					{optionSapExcel && (
						<div className='box '
						onClick={downloadSapExcel}
						>
							<Check size={14} color="#3676F5" />
							<div className='presentation'>
								<h1>formato-sap.xlsx</h1>
								<p>Excel en formato SAP</p>
							</div>
						</div>
					)}
					{optionBulkTemplate && (
						<div className='box '
						onClick={downloadBulkTemplate}
						>
							<Check size={14} color="#3676F5" />
							<div className='presentation'>
								<h1>formato-carga-masiva.xlsx</h1>
								<p>Excel para carga masiva</p>
							</div>
						</div>
					)}
					</div>
				)}
			</div>

			<div className='bottom-area'>
				<button className='button-cancel'
				onClick={(e) => {
					actionMenuNormal()
				}}
				>Cerrar</button>
			</div>
		</div>
	)
}
